export default function AccountDeletedIllustration(
  props: React.ComponentPropsWithoutRef<"svg">
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 332 145"
      {...props}
    >
      <text
        x="50%"
        y="50%"
        textAnchor="middle"
        dominantBaseline="middle"
        fontSize="150"
        fill="currentColor"
        fontFamily="Arial, sans-serif"
        fontWeight="bold"
      >
        404
      </text>
    </svg>
  );
}
